/* src/app/acs-chat/components/conversation-list/conversation-list.scss */
.conversation-list {
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}
.search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  flex-shrink: 0;
}
.search-bar input {
  flex: 1;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  font-size: 14px;
  font-family: inherit;
  background: #fff;
  padding: 8px 12px;
}
.search-bar input::placeholder {
  color: #aaa;
}
.search-bar input:focus {
  border-color: #5ba4b5;
}
.search-bar .search-icon {
  flex-shrink: 0;
}
.thread-list {
  flex: 1;
  overflow-y: auto;
}
.convo-row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  border-bottom: 1px solid #eee;
  transition: background 0.15s;
  position: relative;
}
.convo-row:hover {
  background: #f8f8f8;
}
.convo-row.active {
  background: #f0f0f0;
}
.unread-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #e8677d;
  flex-shrink: 0;
}
.initials-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #7b8a9e;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  flex-shrink: 0;
  text-transform: uppercase;
  line-height: 1;
}
.convo-body {
  flex: 1;
  min-width: 0;
}
.top-row {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 3px;
}
.bottom-row {
  display: flex;
  align-items: center;
}
.convo-name {
  font-weight: 700;
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.convo-time {
  font-size: 11px;
  color: #999;
  flex-shrink: 0;
  white-space: nowrap;
}
.convo-preview {
  font-size: 13px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.empty-hint {
  text-align: center;
  color: #999;
  padding: 24px 14px;
  font-size: 14px;
  line-height: 1.5;
}
/*# sourceMappingURL=conversation-list.css.map */
